import createCache from '@emotion/cache';

window.__webpack_nonce__ = window.csp_nonce;

export const myCache = createCache({
  key: 'my-prefix-key',
  nonce: window.csp_nonce,
});
